import TitleBar from "@/components/elements/TitleBar/TitleBar"

const VistaSuperPlastHs = () => {
    return (
        <>
            <TitleBar title="Page not found" />
        </>
    )
}

export default VistaSuperPlastHs